const calculateUserTestByTags = (userTestTagData: any[], tags: any[]) => {
  let sum = 0;

  if (!tags.length) {
    userTestTagData.forEach(element => {
      sum += element.count;
    });
    return sum;
  }

  userTestTagData.forEach(element => {
    sum += (tags.find(tag => (String(tag.id) === String(element.tagId) || String(tag.value) === String(element.tagId)))) ? element.count : 0;
  });
  return sum;
}


export default calculateUserTestByTags